export default __webpack_public_path__ + "static/media/empty_state_wallet.f33fa2b9.svg";